import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Native `confirmationDisplayType` pipe — a verbatim port of the v1
 * `confirmationDisplayType.filter.js` the FROZEN baseline renders the integration
 * read-view with (resolve the display-type id against the v1 `confirmationDisplayTypes`
 * constant via loose `==` ["Coerce string to number"], then TRANSLATE the name; else '').
 * Previously bridged to `$filter('confirmationDisplayType')` via $injector (no native
 * translate runtime existed); now that the translate bridge is drained it resolves id→name
 * natively and translates via ngx `TranslateService`. Byte-identical to angular-translate
 * incl. its translationId TRIM — the id="1" name carries a trailing space and angular-translate
 * returns it trimmed (a missing key falls back to the TRIMMED id), so we `.instant(name.trim())`.
 * Proven gate-blind by account-parity/_diag-filter-translate-check.mjs (0/66 across all 4 ports).
 * Kept LOCAL + standalone (barrel-free).
 */
const CONFIRMATION_DISPLAY_TYPES: ReadonlyArray<{ id: string; name: string }> = [
  { id: '1', name: 'Integrated - basic sharing component attached to an element ' },
  { id: '2', name: 'Fullscreen - basic sharing component overlaid on page' },
  { id: '3', name: 'Immersive - a complete personalized guest experience (New)' },
];

@Pipe({ name: 'confirmationDisplayType' })
export class ConfirmationDisplayTypeBridgePipe implements PipeTransform {
  private readonly translateSvc = inject(TranslateService);
  transform(value: any): string {
    const displayType = CONFIRMATION_DISPLAY_TYPES.find((d) => d.id == value);
    return displayType ? this.translateSvc.instant(displayType.name.trim()) : '';
  }
}
